import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const deleteAccountConfirm = createAsyncThunk(
	'userSettings/deleteAccountConfirm',
	async (credentials: any, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.deleteAccountConfirm),
);
